"use client";

import { useTranslations } from "next-intl";
import { useEffect } from "react";
import { Section, Container } from "@/components/craft";
import { Button } from "@/components/ui/button";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations("common");

  useEffect(() => {
    console.error("[Error Boundary]", error);
  }, [error]);

  return (
    <Section>
      <Container>
        <div className="flex flex-col items-center justify-center min-h-[50vh] text-center">
          <h1 className="text-4xl font-bold mb-4">{t("error")}</h1>
          <p className="mb-8">{t("errorDescription")}</p>
          <Button onClick={reset} className="not-prose mt-6">
            {t("retry")}
          </Button>
        </div>
      </Container>
    </Section>
  );
}
